/**
 * @file index.ts
 *
 * @description 多言語対応の翻訳データを統合するファイル。
 *
 * @remarks
 * - 翻訳データはすべて `MessagesRecord` に準拠する必要があります。
 * - 型定義 (`types.ts`) を更新した場合、このファイルでエラーが発生する可能性があります。その際は翻訳データを修正してください。
 */

import { ja } from './transJA'
import { en } from './transEN'
import type { MessagesRecord } from './types'

const data: MessagesRecord = {
  ja,
  en
}

export { data }
